// Action Cable consumer for WebSocket connections
import { createConsumer } from '@rails/actioncable'

// Create consumer connected to /cable endpoint
export const consumer = createConsumer()

export default consumer
